/**
 * Persona-prefixed paths for the shared service factories.
 *
 * tenant-onboarding passes `{ persona }` (its session's `w` / `t` / `o` / `e`), so a
 * call the same factory makes from several personas goes to `/v1/<persona>/<rest>`.
 * ds-external passes nothing and keeps the un-prefixed path: its routes are public,
 * token-authenticated ones. A call made from one persona only writes its path as a
 * literal (`/v1/w/templates`) instead.
 */
export interface ServiceOptions {
  persona?: () => string | null;
}

export function makePersonaPath(opts?: ServiceOptions) {
  return (rest: string, version = 'v1'): string => {
    const persona = opts?.persona?.();
    return persona ? `/${version}/${persona}/${rest}` : `/${version}/${rest}`;
  };
}
